module.exports = __webpack_public_path__ + "static/media/icon-th-list.dfe0b2b0.svg";